import { blockType } from "../constants";
import { DividerBlockSchema } from "../schema";
import type { Divider } from "../types";

export const create: Divider["create"] = () => {
  return DividerBlockSchema.parse({
    type: blockType,
    config: {
      spacing: "medium",
      width: "medium",
    },
  });
};
